// Utility functions for building email body content for diagnostics and reporting

/**
 * Builds a plain text body for diagnostics email/report.
 * @param {object} messageCard 
 * @param {object} adaptiveCard 
 * @param {object} combinedDiagnostics 
 * @param {object} entityExtractionDiagnostics 
 * @returns {string}
 */
export function buildTextBody(messageCard, adaptiveCard, combinedDiagnostics, entityExtractionDiagnostics) {
    var body = 'Sending us this email message means you agree to the Terms of Use (https://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default.aspx) and Privacy Statement (https://privacy.microsoft.com/privacystatement)\n';
    body += '\n(Please review the information below to make sure it doesn\'t include any personal information.)\n';

    if (adaptiveCard && messageCard) {
        body += '\nBoth Adaptive Card and Message Card found\n';
    } else if (adaptiveCard) {
        body += '\nAdaptive Card found\n';
    } else if (messageCard) {
        body += '\nMessage Card found\n';
    } else {
        body += '\nNo card found\n';
    }

    var jsonFormatted = JSON.stringify(combinedDiagnostics, null, 4);
    body += '\nDiagnostics:\n';
    body += jsonFormatted;
    return body;
}

/**
 * Builds an HTML body for diagnostics email/report.
 * @param {object} messageCard 
 * @param {object} adaptiveCard 
 * @param {object} combinedDiagnostics 
 * @param {object} entityExtractionDiagnostics 
 * @returns {string}
 */
export function buildBody(messageCard, adaptiveCard, combinedDiagnostics, entityExtractionDiagnostics) {
    var $body = $('<div>');
    $body.html('<p>Sending us this email message means you agree to the <a href="https://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default.aspx">Terms of Use</a> and <a href="https://privacy.microsoft.com/privacystatement">Privacy Statement</a>.</p>'
        + '<p><b>(Please review the information below to make sure it doesn\'t include any personal information.)</b></p>'
        + '<br />');

    var jsonFormatted;

    if (adaptiveCard && messageCard) {
        $body.append($('<p>').text('Both Adaptive Card and Message Card found'));
    } else if (adaptiveCard) {
        $body.append($('<p>').text('Adaptive Card found'));
    } else if (messageCard) {
        $body.append($('<p>').text('Messsage Card found'));
    } else {
        $body.append($('<p>').text('No card found'));
    }

    jsonFormatted = JSON.stringify(combinedDiagnostics, null, 4);
    $body.append($('<p>').text('Diagnostics:'));
    $body.append($('<pre>').text(jsonFormatted));

    jsonFormatted = JSON.stringify(entityExtractionDiagnostics, null, 4);
    $body.append($('<p>').text('Entity Extraction Diagnostics:'));
    $body.append($('<pre>').text(jsonFormatted));

    if (adaptiveCard) {
        jsonFormatted = JSON.stringify(adaptiveCard, null, 4);
        $body.append($('<p>').text('Adaptive Card:'));
        $body.append($('<pre>').text(jsonFormatted));
    }

    if (messageCard) {
        jsonFormatted = JSON.stringify(messageCard, null, 4);
        $body.append($('<p>').text('Message Card:'));
        $body.append($('<pre>').text(jsonFormatted));
    }

    var bodyHtml = $body.html();

    if (typeof MAX_HTML_LENGTH !== 'undefined' && bodyHtml.length > MAX_HTML_LENGTH){
        return bodyHtml.toString();
    } else {
        return bodyHtml;
    }
}
